import { createContext, useState } from 'react'
import { useRoutes } from 'react-router-dom';
import router from 'src/router';
import { IntlProvider } from 'react-intl';
import { AuthProvider } from './contexts/JWTAuthContext';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { messages, supportedLanguages } from './translations/translations'

export const LocalizationContext = createContext({
  userLanguage: '',
  setLanguage: (newLanguage: string) => {}
});

function App() {

  const content = useRoutes(router);
  const [userLanguage, setUserLanguage] = useState(() => {
    // Get language from localStorage or default to 'en'
    const storedLanguage = localStorage.getItem('userLanguage');
    return storedLanguage && Object.keys(supportedLanguages).includes(storedLanguage)
      ? storedLanguage
      : 'en';
  });

  const setLanguage = (language: string) => {
    if (Object.keys(supportedLanguages).includes(language)) {
      setUserLanguage(language);
      localStorage.setItem('userLanguage', language);
    }
  };

  return (
    <ThemeProvider>
      <CssBaseline />
      <LocalizationContext.Provider value={{userLanguage, setLanguage}}>
        <IntlProvider locale={userLanguage} messages={messages[userLanguage]}>
          <AuthProvider>{content}</AuthProvider>
        </IntlProvider>
      </LocalizationContext.Provider>
    </ThemeProvider>
  );
}
export default App;
